<template>
  <va-create-layout>
    <departments-form :title="title" :item="item"></departments-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
